
import Vue from 'vue'
import SwitchLocale from '@/components/SwitchLocale.vue'
import { handleAxiosException } from '@/api'
import { passwordApi } from '@/api/auth/password'
import { rulePassword, ruleRequired } from '@/utils/rules'
import snackbarStore from '@/store/snackbarStore'
import { AxiosResponse } from 'axios'

export default Vue.extend({
  name: 'RequestPasswordReset',
  components: {
    SwitchLocale,
  },
  props: {
    token: { type: String, required: true },
  },
  data: () => ({
    password: undefined as string | undefined,
    password2: undefined as string | undefined,
    showPassword: false,
    showConfirm: false,
    sending: false,
  }),
  methods: {
    toggleShowConfirm() {
      this.showConfirm = !this.showConfirm
    },
    toggleShowPassword() {
      this.showPassword = !this.showPassword
    },
    async confirmReset() {
      this.sending = false
      if (this.password) {
        try {
          await passwordApi.resetPassword(this.password, this.token)
          this.$router.push('/login')
        } catch (e) {
          snackbarStore.setSnackbar({ text: this.$t(handleAxiosException(e, (r: AxiosResponse) => r.data?.message ?? 'error.sending')) as string, color: 'error' })
        }
      }
      this.sending = false
    },
    isTrot(): boolean {
      return !!process.env.VUE_APP_IS_TROT
    },
  },
  computed: {
    rulePassword() {
      return [ruleRequired].concat(rulePassword)
    },
    confirmPasswordError(): string|undefined {
      if (this.password === this.password2) {
        return undefined
      } else {
        return this.$t('form.confirm_password.required') as string
      }
    },
    canSend(): boolean {
      return this.rulePassword.every(f => f(this.password ?? '') === true) && !this.confirmPasswordError
    },
  },
})
